// Generated from SVG to React Component
import React, { SVGProps } from "react";

export const TargetMd = ({ color = "black", ...props }: SVGProps<SVGSVGElement>) => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <g clip-path="url(#clip0_11746_177)">
            <path d="M14.1663 9.99992C14.1663 12.3011 12.3008 14.1666 9.99967 14.1666C7.69849 14.1666 5.83301 12.3011 5.83301 9.99992C5.83301 7.69874 7.69849 5.83325 9.99967 5.83325" stroke={color} strokeWidth="1.5" strokeLinecap="round" />
            <path d="M11.667 1.83345C11.1285 1.72413 10.5711 1.66675 10.0003 1.66675C5.39795 1.66675 1.66699 5.39771 1.66699 10.0001C1.66699 14.6024 5.39795 18.3334 10.0003 18.3334C14.6027 18.3334 18.3337 14.6024 18.3337 10.0001C18.3337 9.42933 18.2762 8.87191 18.167 8.33341" stroke={color} strokeWidth="1.5" strokeLinecap="round" />
            <path d="M13.8359 6.16414L10 10.0001M13.8359 6.16414L13.5651 5.12616C13.3599 4.33984 13.6408 3.43271 14.2906 2.78295L15.2483 1.82513C15.5034 1.57009 15.8982 1.63316 15.9787 1.94181L16.4091 3.59102L18.0583 4.02132C18.3669 4.10184 18.43 4.49667 18.1749 4.75172L17.2172 5.70954C16.5674 6.35929 15.6602 6.64012 14.8739 6.43496L13.8359 6.16414Z" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </g>
        <defs>
            <clipPath id="clip0_11746_177">
                <rect width="20" height="20" fill="white" />
            </clipPath>
        </defs>
    </svg>

);
